import React from "react"
import { ContainerFull } from "../components/GeneralComponents"
import styled from "styled-components"

const H1 = styled.h1`
  font-size: 2.4rem;
  color: ${(props) => props.theme.primary};
  margin-bottom: 1em;
`
const H2 = styled.h2`
  font-size: 1.5rem;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
`

export function Privacy(): JSX.Element {
    return (
        <ContainerFull
            style={{
                fontFamily: '"Rubik", sans-serif',
                maxWidth: 800,
                margin: "0 auto",
                fontSize: "1.25rem",
                lineHeight: 1.7,
            }}
        >
            <H1>Privacy Policy</H1>

            <H2>1. Introduction & Scope</H2>
            <p>
                This Privacy Policy explains how Pananosis Laboratories LLC ("PLab Sequencing," "PLab," "we," "us," or "our") collects, uses, discloses, retains, and protects your personal information when you:
            </p>
            <ul>
                <li>Use our website, platforms, software, or services ("Service");</li>
                <li>Interact with us via email, phone, or in person; or</li>
                <li>Place orders or create an account.</li>
            </ul>
            <p>
                By using our Service, you agree to the collection and use of information as outlined here. If you disagree, please do not use our Service.
            </p>

            <H2>2. Definitions</H2>
            <ul>
                <li><strong>Personal Data:</strong> Any information that identifies or is linked to you (e.g., name, email, billing and account details).</li>
                <li><strong>Usage Data:</strong> Automatically collected technical data (e.g., browser type, device, IP address, pages visited, timestamps).</li>
                <li><strong>Cookies and Tracking Technologies:</strong> Files/scripts used to manage session data and improve experience.</li>
                <li><strong>Service Providers:</strong> Third parties that assist us in fulfilling orders and operating the Service.</li>
            </ul>

            <H2>3. Information We Collect</H2>
            <ul>
                <li><strong>Account & Profile Information:</strong> Name, affiliation, email, billing address, payment method, purchase history.</li>
                <li><strong>Sample Metadata:</strong> Information about biological samples submitted for processing.</li>
                <li><strong>Usage Data</strong> (as defined above).</li>
                <li><strong>Communications:</strong> Support tickets, feedback, and direct correspondence.</li>
            </ul>

            <H2>4. How We Use Your Information</H2>
            <ul>
                <li>Operate, maintain, and deliver our Service;</li>
                <li>Create and manage your account and process orders;</li>
                <li>Provide results, billing, and customer support;</li>
                <li>Communicate product updates and marketing offers (opt-out available);</li>
                <li>Comply with legal obligations and protect our rights;</li>
                <li>Improve and analyze the Service, including usage trends.</li>
            </ul>

            <H2>5. Cookies & Tracking Technology</H2>
            <p>
                We use cookies for authentication, preferences, analytics, and service functionality. You can manage cookie settings in your browser. Disabling essential cookies may impact usability.
            </p>

            <H2>6. Sharing & Disclosure</H2>
            <ul>
                <li>With Service Providers assisting in operations;</li>
                <li>In corporate transactions (e.g., merger, sale), with notice;</li>
                <li>To comply with legal obligations or requests;</li>
                <li>With affiliates or contractors bound to this policy;</li>
                <li>With your explicit consent or when you publicly share content.</li>
            </ul>

            <H2>7. Data Retention</H2>
            <p>
                We retain personal and project data as needed to fulfill services, comply with regulations, and resolve disputes. Usage logs are stored per internal policies.
            </p>

            <H2>8. International Data Transfers</H2>
            <p>
                Data may be processed outside your jurisdiction. We use legally approved safeguards (e.g., transfer agreements) to protect your data.
            </p>

            <H2>9. Security Measures</H2>
            <p>
                We implement encryption, secure servers, and access controls. However, no system is completely secure.
            </p>

            <H2>10. Children’s Privacy</H2>
            <p>
                Our services are not intended for children under 13. We do not knowingly collect data from minors. If we learn of such data, we will delete it promptly.
            </p>

            <H2>11. Third-Party Links</H2>
            <p>
                Our website may contain links to third-party sites. We are not responsible for their privacy practices or content.
            </p>

            <H2>12. Your Rights and Choices</H2>
            <p>
                Depending on your location, you may have rights to:
            </p>
            <ul>
                <li>Access, correct, or delete your personal information;</li>
                <li>Restrict or object to processing;</li>
                <li>Request data portability;</li>
                <li>Withdraw consent where applicable;</li>
                <li>Opt out of marketing communications.</li>
            </ul>
            <p>
                Submit requests to: <a href="mailto:legal@plabsequencing.com">legal@plabsequencing.com</a>
            </p>

            <H2>13. Updates to This Policy</H2>
            <p>
                We may revise this Privacy Policy. Continued use after updates indicates your acceptance. The latest version will always include an effective date.
            </p>

            <H2>14. Contact Us</H2>
            <p>
                Pananosis Laboratories LLC<br />
                Email: <a href="mailto:legal@plabsequencing.com">legal@plabsequencing.com</a>
            </p>

            <p style={{ color: "#888", marginTop: 32, fontSize: "1.1rem" }}>
                {/* Last Updated: {new Date().toLocaleDateString()} */}
                Last Updated: 06/10/2025
            </p>
        </ContainerFull>
    )
}
